import { RadioButton } from '@sravni/react-design-system/lib/RadioButton';
import { useIsMobile, useStyles } from '@sravni/react-utils';
import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';

import { FILTERS_NAME, RATING_TYPES } from '../../../../constants/filters';
import { useFilters } from '../../../../store/hooks/filters';
import { useAppDispatch } from '../../../../store/hooks/redux';
import { setFilters } from '../../../../store/reducers/filters';

import styles from './rating-type-buttons.module.scss';

export const RatingTypeButtons = () => {
  const isMobile = useIsMobile();
  const cx = useStyles(styles);
  const filters = useFilters();
  const { organizationType, ratingType, service } = filters;
  const dispatch = useAppDispatch();

  if (!service) return null;

  const organizationHelper = getOrganizationHelpers(organizationType);

  const options = [
    {
      label: 'Продукты',
      value: RATING_TYPES.Products,
    },
    {
      label: organizationHelper.namesType.bigFirstCharMulti,
      value: RATING_TYPES.Organizations,
    },
  ];

  const handleChange = (value: RATING_TYPES) => {
    const newFilters = {
      ...filters,
      [FILTERS_NAME.RatingType]: value,
    };

    dispatch(setFilters(newFilters));
  };

  return (
    <RadioButton
      options={options}
      size={36}
      onChange={handleChange}
      value={ratingType}
      className={cx(isMobile ? 'h-mb-12' : 'h-mb-16', 'radioButtons')}
    />
  );
};
